<crm-auto-complete
  #projectAutoComplete
  [(value)]="selectedProject"
  (valueChange)="selectedProjectChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  [disabled]="disabled"
  [inputStyle]="inputStyle"
  [suggestions]="projects"
  [virtualScroll]="true"
  [virtualScrollItemSize]="75"
  [inputStyleClass]="inputStyleClass"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [showClear]="showClear"
  [isError]="isError"
  [loading]="loading"
  (completeMethod)="customSearch ? projectSearch.emit($event.query) : searchProject($event.query)">
  <ng-template
    #itemTemplate
    let-project="item">
    <ng-container *ngIf="toProject(project) as project">
      <div class="flex justify-content-between align-items-center white-space-normal gap-2">
        <div>
          <p
            *ngIf="project.name?.length > 30; else shortNameTemplate"
            class="font-medium"
            [pTooltip]="project.name"
            tooltipPosition="top">
            <span [innerHTML]="highlightMatchText(project.name) | truncate: 72 | safeHtml"></span>
          </p>
          <p class="font-medium text-gray-500">{{ project.deadline | date: 'dd.MM.yyyy' }}</p>
          <p class="font-medium text-green-500">{{ project.responsible?.name }}</p>
        </div>
        <div class="white-space-nowrap">
          <crm-status-label
            *ngIf="project.status"
            [name]="project.status.name"
            [color]="project.status.color"></crm-status-label>
        </div>
      </div>

      <ng-template #shortNameTemplate>
        <p class="font-medium">
          <span [innerHTML]="highlightMatchText(project.name) | truncate: 72 | safeHtml"></span>
        </p>
      </ng-template>
    </ng-container>
  </ng-template>
</crm-auto-complete>
